import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

type Props = {
  status?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

export default function EyeButton({
  status = false,
  onClick = () => {},
}: Props) {
  return (
    <button
      type='button'
      onClick={onClick}
      className='absolute top-2 right-2 w-5'
      tabIndex={-1}
    >
      {status ? (
        <EyeIcon className='text-zinc-600' />
      ) : (
        <EyeSlashIcon className='text-zinc-600' />
      )}
    </button>
  );
}
